export enum LocalStorageKeys {
    STEP = 'step',
    CART = 'cart',
    SEATS = 'seats',
    TIMESLOT = 'timeslot',
    GENERIC_BOOKING_FIELDS = 'genericBookingFields',
    LANG = 'lang',
    COUPON = 'coupon',
    UTM_PARAMS = 'utmParams',
}
